module.exports = __webpack_public_path__ + "k.no1.7c0c9994.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/k.no1.jpg
// module id = m6Bu
// module chunks = 0